// extracted by mini-css-extract-plugin
export var dropdownContainer = "_jr-0";
export var leftAlign = "_jr-4";
export var listItem = "_jr-2";
export var listItemWrapper = "_jr-1";
export var operationText = "_jr-3";